<template>
<div class="modal fade" :data-backdrop="backdrop" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div :class="modalDialogClasses" class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ shownTitle }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <slot name="body">{{ body }}</slot>
            </div>
            <div class="modal-footer">
                <slot :close="hide" name="buttons">
                    <slot :close="hide" name="cancelButton">
                        <button @click="cancel" type="button" class="btn btn-secondary">
                            <slot name="cancelButtonContent">{{ $t("common.cancel") }}</slot>
                        </button>
                    </slot>
                    <slot :close="hide" name="okButton">
                        <button @click="ok" type="button" class="btn btn-primary">
                            <slot name="okButtonContent">{{ $t("common.ok") }}</slot>
                        </button>
                    </slot>
                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from "jquery";
import "bootstrap/js/dist/modal";

let modalsCount = 0;

//TODO maybe buttons property
const Modal = {
    props: {
        title: {
            type: String
        },
        backdrop: {
            type: [String, Boolean],
            default: "static"
        },
        modalDialogClasses: {
            type: Array,
            required: false
        }
    },
    inject: ["$validator"],
    data() {
        return {
            deferred: null,
            body: null,
            shownTitle: this.title,
            isClosedByButton: false
        };
    },
    methods: {
        show(params) {
            ++modalsCount;

            this.isClosedByButton = false;

            if (params) {
                if (typeof params === "string") {
                    this.body = params;
                } else {
                    this.body = params.body;
                    if (params.title) {
                        this.shownTitle = params.title;
                    }
                }
            }
            
            this.deferred = new $.Deferred();

            const modal = $(this.$el);
            modal.modal("show");

            modal.one("hidden.bs.modal", () => {
                --modalsCount;
                if (modalsCount > 0) {
                    $(document.body).addClass("modal-open");
                }

                if (!this.isClosedByButton) {
                    this.deferred.resolve(false);
                }
            });

            modal.on("shown.bs.modal", () => {
                this.$emit("shown");
            });

            modal.on("hidden.bs.modal", () => {
                this.$emit("hidden");
            });

            return this.deferred.promise();
        },

        hide() {
            $(this.$el).modal("hide");
            this.$emit("hidden");
        },

        ok() {
            this.hide();
            this.deferred.resolve(true);
        },

        cancel() {
            this.isClosedByButton = true;
            this.hide();
            this.deferred.resolve(false);
        }
    }
};

export default Modal;
</script>